import React from "react";
import Modal from "react-bootstrap/Modal";
import "./ReminderModal.scss";

import filePDF from "../../../assets/icons/file-pdf-24.svg";

import closeIcon from "../../../assets/close.svg";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

class ReminderModal extends React.Component {
  state = {
    documentItems: null,
    checkBox: {},
    isSelectAll: false,
    selectAll: {},
  };
  documentItems = {};
  checkBox = {};
  selectAll = {};

  documentList = () => {
    let documentItems = {};
    let checkBox = {};
    let selectAll = {};
    for (let doc of this.props.documents) {
      if (documentItems[doc.documentId]) {
        documentItems[doc.documentId] = [...documentItems[doc.documentId], doc];
      } else {
        documentItems[doc.documentId] = [doc];
      }
    }

    Object.keys(documentItems).map((doc, keyIndex) => {
      documentItems[doc].map((item) => (checkBox[item.id] = false));
      return (selectAll[keyIndex] = false);
    });

    this.setState({
      documentItems,
      checkBox,
      selectAll,
    });
    return documentItems;
  };

  handleCheckBox(e, checkBoxId, docId, keyIndex) {
    let value = e.target.checked;
    this.setState(
      (prevState) => ({
        isSelectAll: false,
        checkBox: {
          ...prevState.checkBox,
          [checkBoxId]: value,
        },
      }),
      () => {
        this.handleDocumnetSelectAll(docId, keyIndex);
      }
    );
  }

  handleDocumnetSelectAll = (docId, keyIndex) => {
    let selectAllStatus = true;

    let getCheckedValues = [...this.state.documentItems[docId]].filter(
      (item) => this.state.checkBox[item.id] === false
    );

    selectAllStatus = getCheckedValues.length > 0 ? false : true;

    this.setState(
      (prevState) => ({
        selectAll: {
          ...prevState.selectAll,
          [keyIndex]: selectAllStatus,
        },
      }),
      () => {
        this.handleGlobalCheckbox();
      }
    );
  };

  handleSelectAllCheckBox(e, doc, keyIndex) {
    let value = e.target.checked;
    this.setState(
      (prevState) => ({
        selectAll: {
          ...prevState.selectAll,
          [keyIndex]: value,
        },
      }),
      () => {
        this.handleGlobalCheckbox();
      }
    );
    this.state.documentItems[doc].map((item) => {
      let checkboxId = item.id;
      return this.setState((prevState) => ({
        isSelectAll: false,
        checkBox: {
          ...prevState.checkBox,
          [checkboxId]: value,
        },
      }));
    });
  }

  selectAllCheckBox(e) {
    const value = e.target.checked;
    Object.keys(this.state.selectAll).map((box) => {
      return this.setState((prevState) => ({
        selectAll: {
          ...prevState.selectAll,
          [box]: value,
        },
      }));
    });

    Object.keys(this.state.checkBox).map((item) => {
      return this.setState((prevState) => ({
        isSelectAll: value,
        checkBox: {
          ...prevState.checkBox,
          [item]: value,
        },
      }));
    });
  }

  handleGlobalCheckbox = () => {
    let globalCheckboxStatus = true;
    const getCheckedValues = Object.keys(this.state.selectAll).filter(
      (selectAllCheckbox) => this.state.selectAll[selectAllCheckbox] === false
    );

    globalCheckboxStatus = getCheckedValues.length > 0 ? false : true;

    this.setState({
      isSelectAll: globalCheckboxStatus,
    });
  };
  render() {
    if (!this.state.documentItems && this.props.documents) {
      this.documentItems = this.documentList();
    }

    return (
      <Modal
        className="reminder-modal"
        size="lg"
        centered
        show={this.props.openReminderModal}
        onHide={this.props.closeModal}
      >
        <div className="reminder-modal-content">
          <div className="header">
            <h3 className="title">Set Recurring Reminders</h3>
            <img
              className="close"
              src={closeIcon}
              alt="close"
              onClick={this.props.closeModal}
            />
          </div>
          <div className="overview-modal-body">
            <div className="container-fluid">
              <p>
                Set recurring reminders for 30,60, & 90 days prior to the
                following dates :
              </p>

              <div
                className="accordion-box"
                style={{ overflowX: "hidden", maxHeight: "47vh" }}
              >
                {this.state.documentItems
                  ? Object.keys(this.documentItems).map((doc, keyIndex) => {
                      return (
                        <Accordion square className="mb-4">
                          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <img
                              src={filePDF}
                              alt="pdf"
                              style={{
                                height: "24px",
                                width: "19px",
                                marginRight: "8px",
                                paddingBottom: "5px",
                              }}
                            />
                            {
                              [...this.state.documentItems[doc]][0]
                                .documentTitle
                            }
                          </AccordionSummary>
                          <AccordionDetails className="grid-container">
                            <FormControlLabel
                              className="grid-item"
                              control={
                                <Checkbox
                                  checked={this.state.selectAll[keyIndex]}
                                  disableRipple="true"
                                  name="selectAll"
                                  color="primary"
                                  id={keyIndex}
                                  onChange={(e) =>
                                    this.handleSelectAllCheckBox(
                                      e,
                                      doc,
                                      keyIndex
                                    )
                                  }
                                />
                              }
                              label="Select All"
                            />
                            {[...this.state.documentItems[doc]].map(
                              (docInfo) => (
                                <FormControlLabel
                                  className="grid-item"
                                  control={
                                    <Checkbox
                                      checked={this.state.checkBox[docInfo.id]}
                                      disableRipple="true"
                                      name={docInfo.id}
                                      color="primary"
                                      onChange={(e) =>
                                        this.handleCheckBox(
                                          e,
                                          docInfo.id,
                                          doc,
                                          keyIndex
                                        )
                                      }
                                    />
                                  }
                                  label={docInfo.dateTitle}
                                />
                              )
                            )}
                          </AccordionDetails>
                        </Accordion>
                      );
                    })
                  : null}
              </div>
            </div>
            <div className="m-footer">
              <FormControlLabel
                className="select-all"
                control={
                  <Checkbox
                    checked={this.state.isSelectAll}
                    disableRipple="true"
                    name="selectAllBox"
                    color="primary"
                    onChange={(e) => this.selectAllCheckBox(e)}
                  />
                }
                label="Select All"
              />
              <button
                className="btn-tertiary cancel-button mr-4"
                onClick={this.props.closeModal}
              >
                Cancel
              </button>
              <button
                className="btn-primary modal-cancel-button mr-4"
                onClick={() =>
                  this.props.saveReminderDates(this.state.checkBox)
                }
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default ReminderModal;
